export default "__VITE_ASSET__B2eQH43$__"